// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Импорт шрифта */

:root {
  --bg-deep: #050810;
  --bg-card: rgba(30, 41, 59, 0.7);
  --accent-primary: #3b82f6;
  --accent-secondary: #f59e0b;
  --text-main: #f8fafc;
  --text-dim: #94a3b8;
  --glass-border: rgba(255, 255, 255, 0.08);
}

/* Базовые настройки фона */
.hero-wrapper {
  background-color: var(--bg-deep);
  /* Сложный градиент для создания глубины */
  background-image: 
    radial-gradient(circle at 0% 0%, rgba(59, 130, 246, 0.15) 0%, transparent 35%),
    radial-gradient(circle at 100% 100%, rgba(245, 158, 11, 0.1) 0%, transparent 35%),
    radial-gradient(circle at 50% 50%, rgba(15, 23, 42, 1) 0%, var(--bg-deep) 100%);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  color: var(--text-main);
  font-family: 'Poppins', sans-serif;
}

/* Навигация с эффектом стекла */
.hero-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 60px;
  position: relative;
  z-index: 100;
  background: rgba(5, 8, 16, 0.5);
  backdrop-filter: blur(15px);
  border-bottom: 1px solid var(--glass-border);
}

.hero-logo {
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -1px;
}

.hero-logo span {
  color: var(--accent-secondary);
  text-shadow: 0 0 15px rgba(245, 158, 11, 0.3);
}

.login-btn-top {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--glass-border);
  color: var(--text-main);
  padding: 10px 24px;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 500;
}

.login-btn-top:hover {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  box-shadow: 0 0 20px rgba(59, 130, 246, 0.4);
  transform: translateY(-1px);
}

/* Центральный контент */
.hero-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 5;
  padding: 10px;
}

.hero-main-logo {
  position: relative;
  margin-bottom: 40px;
}

.logo-inner {
  width: 110px;
  height: 110px;
  background: linear-gradient(145deg, #1e293b, #0f172a);
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  border: 1px solid var(--glass-border);
  transform: rotate(-6deg);
  transition: transform 0.5s ease;
}

.hero-main-logo:hover .logo-inner {
  transform: rotate(0deg) scale(1.05);
}

.logo-symbol {
  font-size: 50px;
  font-weight: 900;
  background: linear-gradient(to bottom, #fff, #3b82f6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.logo-glow {
  position: absolute;
  top: 50%; left: 50%;
  width: 200px; height: 200px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.3) 0%, transparent 70%);
  filter: blur(30px);
  transform: translate(-50%, -50%);
}

.hero-title {
  font-size: clamp(32px, 5vw, 64px);
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 25px;
}

.accent-text {
  background: linear-gradient(90deg, #60a5fa, #3b82f6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

.hero-subtitle {
  color: var(--text-dim);
  max-width: 650px;
  font-size: 18px;
  margin-bottom: 40px;
}

.action-btn {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: white;
  padding: 18px 45px;
  border: none;
  border-radius: 18px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 10px 30px rgba(37, 99, 235, 0.3);
  transition: all 0.3s ease;
}

.action-btn:hover {
  box-shadow: 0 15px 40px rgba(37, 99, 235, 0.5);
  transform: translateY(-3px);
}

/* --- МОДАЛЬНОЕ ОКНО --- */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.85);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-glass {
  background: linear-gradient(165deg, rgba(30, 41, 59, 0.9), rgba(15, 23, 42, 0.9));
  border: 1px solid var(--glass-border);
  padding: 45px;
  border-radius: 32px;
  width: 100%;
  max-width: 420px;
  position: relative;
  box-shadow: 0 50px 100px -20px rgba(0, 0, 0, 0.7);
}

.modal-title {
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 10px;
  background: linear-gradient(to right, #fff, #cbd5e1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.form-group input {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--glass-border);
  border-radius: 16px;
  padding: 15px 20px;
  color: white;
  width: 100%;
  font-size: 16px;
  transition: all 0.3s ease;
}

.form-group input:focus {
  background: rgba(30, 41, 59, 0.8);
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
  outline: none;
}

.submit-btn {
  background: #ffffff; /* Белая кнопка для контраста, как в Apple стиле */
  color: #050810;
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  /* background: #e2e8f0; */
  transform: scale(1.01);
}

/* Фоновые декоративные сферы */
.bg-shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  z-index: 1;
  opacity: 0.4;
}

.shape-1 {
  width: 400px; height: 400px;
  background: var(--accent-primary);
  top: -100px; right: -50px;
}

.shape-2 {
  width: 300px; height: 300px;
  background: var(--accent-secondary);
  bottom: -50px; left: -50px;
}

@media (max-width: 768px) {
  .hero-nav { padding: 15px 25px; }
  .hero-title { font-size: 32px; }
  .modal-glass { padding: 10px 14px; }
}
.hero-subtitle {
  color: var(--text-dim);
  max-width: 650px;
  font-size: 16px;
  margin-bottom: 30px;
}
/* --- Обновленная модалка --- */
.modal-glass {
  background: #1e293b; /* Глубокий темно-синий из примера */
  padding: 0px 40px 40px; /* Увеличил верхний отступ для кнопки */
  border-radius: 28px;
  width: 100%;
  /* max-width: 440px; */
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);
}

/* --- Кнопка закрытия как на скриншоте --- */
.close-modal {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  background: linear-gradient(90deg, #60a5fa, #3b82f6); /* Светлый фон как на фото */
  border: none;
  border-radius: 8px; /* Слегка скругленные края */
  color: #fff; /* Темный крестик */
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  line-height: 1;
  padding: 0;
  z-index: 10;
}

.close-modal:hover {
  background: #ffffff;
  transform: scale(1.1);
}

/* --- Заголовок и форма --- */
.modal-title {
  color: #ffffff;
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 10px;
  text-align: center;
}

.modal-subtitle {
  color: #94a3b8;
  font-size: 15px;
  margin-bottom: 30px;
  text-align: center;
}

/* Поля ввода (убрал лишние тени) */
.form-group input {
  width: 89%;
  background: #0f172a; /* Еще более темный фон для инпута */
  border: 1px solid #334155;
  border-radius: 10px;
  padding: 12px 16px;
  color: #ffffff;
  font-size: 14px;
}

/* Белая кнопка Войти */
.submit-btn {
  width: 100%;
  background: linear-gradient(90deg, #60a5fa, #3b82f6);
  color: #fff;
  padding: 14px;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/style/HeroSection.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAGlB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,0CAA0C;EAC1C;;;mFAGiF;EACjF,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,qCAAqC;EACrC,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ,EAAE,SAAS;EACnB,YAAY,EAAE,aAAa;EAC3B,gFAAgF;EAChF,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iFAAiF;EACjF,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,mBAAmB,EAAE,kDAAkD;EACvE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY,EAAE,aAAa;EAC3B,iCAAiC;EACjC,WAAW,EAAE,YAAY;AAC3B;;AAEA;EACE,YAAY,EAAE,aAAa;EAC3B,mCAAmC;EACnC,aAAa,EAAE,WAAW;AAC5B;;AAEA;EACE,YAAY,kBAAkB,EAAE;EAChC,cAAc,eAAe,EAAE;EAC/B,eAAe,kBAAkB,EAAE;AACrC;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,gCAAgC;AAChC;EACE,mBAAmB,EAAE,oCAAoC;EACzD,sBAAsB,EAAE,uCAAuC;EAC/D,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oDAAoD,EAAE,4BAA4B;EAClF,YAAY;EACZ,kBAAkB,EAAE,4BAA4B;EAChD,WAAW,EAAE,mBAAmB;EAChC,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,UAAU;EACV,mBAAmB,EAAE,oCAAoC;EACzD,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,oDAAoD;EACpD,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* Импорт шрифта */\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');\n\n:root {\n  --bg-deep: #050810;\n  --bg-card: rgba(30, 41, 59, 0.7);\n  --accent-primary: #3b82f6;\n  --accent-secondary: #f59e0b;\n  --text-main: #f8fafc;\n  --text-dim: #94a3b8;\n  --glass-border: rgba(255, 255, 255, 0.08);\n}\n\n/* Базовые настройки фона */\n.hero-wrapper {\n  background-color: var(--bg-deep);\n  /* Сложный градиент для создания глубины */\n  background-image: \n    radial-gradient(circle at 0% 0%, rgba(59, 130, 246, 0.15) 0%, transparent 35%),\n    radial-gradient(circle at 100% 100%, rgba(245, 158, 11, 0.1) 0%, transparent 35%),\n    radial-gradient(circle at 50% 50%, rgba(15, 23, 42, 1) 0%, var(--bg-deep) 100%);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  color: var(--text-main);\n  font-family: 'Poppins', sans-serif;\n}\n\n/* Навигация с эффектом стекла */\n.hero-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 60px;\n  position: relative;\n  z-index: 100;\n  background: rgba(5, 8, 16, 0.5);\n  backdrop-filter: blur(15px);\n  border-bottom: 1px solid var(--glass-border);\n}\n\n.hero-logo {\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -1px;\n}\n\n.hero-logo span {\n  color: var(--accent-secondary);\n  text-shadow: 0 0 15px rgba(245, 158, 11, 0.3);\n}\n\n.login-btn-top {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid var(--glass-border);\n  color: var(--text-main);\n  padding: 10px 24px;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  font-weight: 500;\n}\n\n.login-btn-top:hover {\n  background: var(--accent-primary);\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 20px rgba(59, 130, 246, 0.4);\n  transform: translateY(-1px);\n}\n\n/* Центральный контент */\n.hero-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  z-index: 5;\n  padding: 10px;\n}\n\n.hero-main-logo {\n  position: relative;\n  margin-bottom: 40px;\n}\n\n.logo-inner {\n  width: 110px;\n  height: 110px;\n  background: linear-gradient(145deg, #1e293b, #0f172a);\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);\n  border: 1px solid var(--glass-border);\n  transform: rotate(-6deg);\n  transition: transform 0.5s ease;\n}\n\n.hero-main-logo:hover .logo-inner {\n  transform: rotate(0deg) scale(1.05);\n}\n\n.logo-symbol {\n  font-size: 50px;\n  font-weight: 900;\n  background: linear-gradient(to bottom, #fff, #3b82f6);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.logo-glow {\n  position: absolute;\n  top: 50%; left: 50%;\n  width: 200px; height: 200px;\n  background: radial-gradient(circle, rgba(59, 130, 246, 0.3) 0%, transparent 70%);\n  filter: blur(30px);\n  transform: translate(-50%, -50%);\n}\n\n.hero-title {\n  font-size: clamp(32px, 5vw, 64px);\n  font-weight: 800;\n  line-height: 1.1;\n  margin-bottom: 25px;\n}\n\n.accent-text {\n  background: linear-gradient(90deg, #60a5fa, #3b82f6);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  display: inline-block;\n}\n\n.hero-subtitle {\n  color: var(--text-dim);\n  max-width: 650px;\n  font-size: 18px;\n  margin-bottom: 40px;\n}\n\n.action-btn {\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\n  color: white;\n  padding: 18px 45px;\n  border: none;\n  border-radius: 18px;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  box-shadow: 0 10px 30px rgba(37, 99, 235, 0.3);\n  transition: all 0.3s ease;\n}\n\n.action-btn:hover {\n  box-shadow: 0 15px 40px rgba(37, 99, 235, 0.5);\n  transform: translateY(-3px);\n}\n\n/* --- МОДАЛЬНОЕ ОКНО --- */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(2, 6, 23, 0.85);\n  backdrop-filter: blur(10px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-glass {\n  background: linear-gradient(165deg, rgba(30, 41, 59, 0.9), rgba(15, 23, 42, 0.9));\n  border: 1px solid var(--glass-border);\n  padding: 45px;\n  border-radius: 32px;\n  width: 100%;\n  max-width: 420px;\n  position: relative;\n  box-shadow: 0 50px 100px -20px rgba(0, 0, 0, 0.7);\n}\n\n.modal-title {\n  font-size: 30px;\n  font-weight: 700;\n  margin-bottom: 10px;\n  background: linear-gradient(to right, #fff, #cbd5e1);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.form-group input {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--glass-border);\n  border-radius: 16px;\n  padding: 15px 20px;\n  color: white;\n  width: 100%;\n  font-size: 16px;\n  transition: all 0.3s ease;\n}\n\n.form-group input:focus {\n  background: rgba(30, 41, 59, 0.8);\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n  outline: none;\n}\n\n.submit-btn {\n  background: #ffffff; /* Белая кнопка для контраста, как в Apple стиле */\n  color: #050810;\n  width: 100%;\n  padding: 16px;\n  border-radius: 16px;\n  font-weight: 700;\n  font-size: 16px;\n  cursor: pointer;\n  border: none;\n  transition: all 0.3s ease;\n}\n\n.submit-btn:hover {\n  /* background: #e2e8f0; */\n  transform: scale(1.01);\n}\n\n/* Фоновые декоративные сферы */\n.bg-shape {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(100px);\n  z-index: 1;\n  opacity: 0.4;\n}\n\n.shape-1 {\n  width: 400px; height: 400px;\n  background: var(--accent-primary);\n  top: -100px; right: -50px;\n}\n\n.shape-2 {\n  width: 300px; height: 300px;\n  background: var(--accent-secondary);\n  bottom: -50px; left: -50px;\n}\n\n@media (max-width: 768px) {\n  .hero-nav { padding: 15px 25px; }\n  .hero-title { font-size: 32px; }\n  .modal-glass { padding: 10px 14px; }\n}\n.hero-subtitle {\n  color: var(--text-dim);\n  max-width: 650px;\n  font-size: 16px;\n  margin-bottom: 30px;\n}\n/* --- Обновленная модалка --- */\n.modal-glass {\n  background: #1e293b; /* Глубокий темно-синий из примера */\n  padding: 0px 40px 40px; /* Увеличил верхний отступ для кнопки */\n  border-radius: 28px;\n  width: 100%;\n  /* max-width: 440px; */\n  position: relative;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);\n}\n\n/* --- Кнопка закрытия как на скриншоте --- */\n.close-modal {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(90deg, #60a5fa, #3b82f6); /* Светлый фон как на фото */\n  border: none;\n  border-radius: 8px; /* Слегка скругленные края */\n  color: #fff; /* Темный крестик */\n  font-size: 20px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  line-height: 1;\n  padding: 0;\n  z-index: 10;\n}\n\n.close-modal:hover {\n  background: #ffffff;\n  transform: scale(1.1);\n}\n\n/* --- Заголовок и форма --- */\n.modal-title {\n  color: #ffffff;\n  font-size: 26px;\n  font-weight: 700;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.modal-subtitle {\n  color: #94a3b8;\n  font-size: 15px;\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n/* Поля ввода (убрал лишние тени) */\n.form-group input {\n  width: 89%;\n  background: #0f172a; /* Еще более темный фон для инпута */\n  border: 1px solid #334155;\n  border-radius: 10px;\n  padding: 12px 16px;\n  color: #ffffff;\n  font-size: 14px;\n}\n\n/* Белая кнопка Войти */\n.submit-btn {\n  width: 100%;\n  background: linear-gradient(90deg, #60a5fa, #3b82f6);\n  color: #fff;\n  padding: 14px;\n  border: none;\n  border-radius: 10px;\n  font-weight: 700;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
